module.exports = __webpack_public_path__ + "img/capital-dance.072053fa.png";